import { render } from "./AsistentFinish.vue?vue&type=template&id=fb2f8cbc"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__